import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
/**
 * @description service to call HTTP request via Axios
 */
class ReportService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        ReportService.vueInstance = app;
        if (!ReportService.vueInstance.axios)
            ReportService.vueInstance.use(VueAxios, axios);
        ReportService.BaseUrl = import.meta.env.VITE_REPORT_URL;
    }
    /**
     * @description set the default HTTP request headers
     */
    static setHeader() {
        ReportService.vueInstance.axios.defaults.headers.common["Authorization"] = `Bearer ${JwtService.getToken()}`;
        ReportService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return ReportService.vueInstance.axios.get(`${ReportService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return ReportService.vueInstance.axios.get(`${ReportService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return ReportService.vueInstance.axios.post(`${ReportService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the UPDATE HTTP request
     * @param resource: string
     * @param slug: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static update(resource, slug, params) {
        return ReportService.vueInstance.axios.put(`${ReportService.BaseUrl}/${resource}/${slug}`, params);
    }
    /**
     * @description Send the PUT HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static put(resource, params) {
        return ReportService.vueInstance.axios.put(`${ReportService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description Send the DELETE HTTP request
     * @param resource: string
     * @returns Promise<AxiosResponse>
     */
    static delete(resource) {
        return ReportService.vueInstance.axios.delete(resource);
    }
}
export default ReportService;
//# sourceMappingURL=ReportService.js.map